var _excluded = ["content", "image", "mobileImage", "isOpen", "onCloseButtonClick", "contentPaddingSpace", "notHideOnClose"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef, useState } from "react";
import PreventPageScroll from "../../../helpers/PreventPageScroll";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useEscClick from "../../../hooks/useEscClick";
import useModalFocus from "../../../hooks/useModalFocus";
import AlignContentOrg from "../../organisms/AlignContentOrg";
import PushOrg from "../../organisms/PushOrg";
import CloseButtonAtm from "./CloseButtonAtm";
import { modalBreakpointValue } from "./common";
import { Overlay, Container, ContentWrapper, MobileImageWrapper, LargeImageWrapper, StyledImage } from "./ModalWithImageMol.styled";
function ModalWithImageMol(_ref) {
  var content = _ref.content,
    image = _ref.image,
    mobileImage = _ref.mobileImage,
    isOpen = _ref.isOpen,
    onCloseButtonClick = _ref.onCloseButtonClick,
    contentPaddingSpace = _ref.contentPaddingSpace,
    notHideOnClose = _ref.notHideOnClose,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenValue = _useState2[0],
    setIsOpenValue = _useState2[1];
  var isSmallOnly = useBreakpoint("small", modalBreakpointValue);
  var isMediumUp = useBreakpoint(modalBreakpointValue);
  var _useModalFocus = useModalFocus(containerRef),
    handleKeyDown = _useModalFocus.handleKeyDown,
    handleFocusOnModalClose = _useModalFocus.handleFocusOnModalClose;
  useEffect(function () {
    if (isOpen !== isOpenValue) {
      setIsOpenValue(isOpen);
    }
  }, [isOpen, isOpenValue]);
  var handleOnCloseClick = function handleOnCloseClick(event) {
    if (!notHideOnClose) {
      setIsOpenValue(false);
    }
    if (onCloseButtonClick) {
      onCloseButtonClick(event);
    }
    handleFocusOnModalClose();
  };
  useEscClick(containerRef, handleOnCloseClick);
  var hasMobileImage = !!mobileImage;
  var isMobileWithoutImage = isSmallOnly && !hasMobileImage;
  var hasCloseButton = !!onCloseButtonClick;
  var closeButtonJsx = /*#__PURE__*/React.createElement(CloseButtonAtm, {
    onClick: handleOnCloseClick,
    isPositionedAbsolute: !isMobileWithoutImage,
    hasBackground: !isMobileWithoutImage
  });
  var contentJsx = isSmallOnly && !mobileImage ? /*#__PURE__*/React.createElement(React.Fragment, null, hasCloseButton ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1
  }, /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "right"
  }, closeButtonJsx)) : null, content) : /*#__PURE__*/React.createElement(React.Fragment, null, hasCloseButton ? closeButtonJsx : null, content);
  if (!isOpenValue) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpenValue ? /*#__PURE__*/React.createElement(PreventPageScroll, null) : null, /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Container, _extends({
    ref: containerRef,
    onKeyDown: handleKeyDown
  }, restProps), isSmallOnly && mobileImage ? /*#__PURE__*/React.createElement(MobileImageWrapper, null, /*#__PURE__*/React.createElement(StyledImage, {
    srcData: mobileImage,
    alt: mobileImage.alt
  })) : null, /*#__PURE__*/React.createElement(ContentWrapper, {
    $paddingSpace: contentPaddingSpace
  }, contentJsx), isMediumUp ? /*#__PURE__*/React.createElement(LargeImageWrapper, null, /*#__PURE__*/React.createElement(StyledImage, {
    srcData: image,
    alt: image.alt
  })) : null)));
}
export default ModalWithImageMol;